import { createReactRenderer } from 'helpers/react-renderer';
import PublishToEcomModal from './PublishToEcomModal';

export default class PublishToEcom {
  /**
   * Constructor is used to create the button binding to either trigger the modal
   * if the user doesn't choose to check the hide modal checkbox or update the
   * "publish_to_ecom" input and save the item
   */
  constructor() {
    this.ui = {};

    $(document)
      .off('.publish-to-ecom')
      .on('click.publish-to-ecom', '.js-publish-to-ecom-modal', e => {
        e.preventDefault();

        this.ui.deleteItemLink = $(e.currentTarget);
        this.ui.saveItemButton = $('#saveButton:visible');
        this.ui.publishToEcomInput = this.ui.deleteItemLink
          .parent()
          .find('input[name="publish_to_ecom"]');

        if (!sessionStorage.getItem(PublishToEcomModal.STORAGE_HIDE_MODAL)) {
          this.initModal();
        } else {
          this.unpublishItem();
        }
      });

    $(document).on('change.publish-to-ecom', '.listing input[name="publish_to_ecom"]', e => {
      if (!e.currentTarget.checked) return;
      const subscriber = window.merchantos.asyncSubscribe.subscribeToFormCall(
        'listing.editfield',
        (data, promise) => {
          // eslint-disable-next-line no-shadow
          promise.then(data => {
            if (!data.success) {
              $(`#${data.field_id}`)
                .prop('disabled', false)
                .prop('checked', false)
                .parent()
                .find('a.js-publish-to-ecom-modal')
                .addClass('hidden');
            }

            subscriber.unsubscribe();
          });
        }
      );
    });
  }

  /**
   * Initialize the modal that confirms the unpublished item
   */
  initModal() {
    const RenderedComponent = createReactRenderer({
      component: PublishToEcomModal,
      props: {
        PublishToEcom: this,
        description: this.ui.publishToEcomInput.data('item-description'),
      },
      selector: '[data-react-root="ReactModal"]',
    });

    RenderedComponent.mount();
  }

  /**
   * Re-enable the checkbox, un-check it and save the item. Doing so
   * will push an event to delete the item inside eCom
   */
  unpublishItem() {
    this.ui.publishToEcomInput.prop('disabled', false).prop('checked', false);

    this.ui.deleteItemLink.addClass('hidden');

    // If there is a "Save" button, click it (Inventory > Item)
    // Else the "onChange" will be triggered (Inventory > Quick Edit)
    if (this.ui.saveItemButton[0]) {
      this.ui.saveItemButton.trigger('click');
    } else {
      this.ui.publishToEcomInput.trigger('change');
    }
  }
}
